<!--  -->
<template>
  <div>
    <el-table
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="id"
        label="ID"
        width="50"
        align="center"
      />
      <!-- <el-table-column
        prop="execute_time"
        label="预定执行时间"
        width="180"
        align="center"
      /> -->
      <el-table-column
        prop="actual_execute_time"
        label="实际执行时间"
        width="180"
        align="center"
      />
      <el-table-column
        prop="name"
        label="执行状态"
        width="180"
        align="center"
      >
        <template scope="scope">
          <el-tag v-if="scope.row.execute_status === 1">{{ scope.row.execute_status_str }}</el-tag>
          <el-tag v-if="scope.row.execute_status === 2" type="success">{{ scope.row.execute_status_str }}</el-tag>
          <!-- <el-tag type="danger">标签五</el-tag> -->
        </template>
      </el-table-column>
      <el-table-column
        prop="name"
        label="支付状态"
        width="180"
        align="center"
      >
        <template scope="scope">
          <el-tag v-if="scope.row.pay_status === 1">{{ scope.row.pay_status_str }}</el-tag>
          <el-tag v-if="scope.row.pay_status === 2" type="success">{{ scope.row.pay_status_str }}</el-tag>
          <el-tag v-if="scope.row.pay_status === 3" type="danger">{{ scope.row.pay_status_str }}</el-tag>
          <!-- <el-tag type="danger">标签五</el-tag> -->
        </template>
      </el-table-column>
      <el-table-column
        prop="tries"
        label="尝试次数"
        align="center"
      />
      <el-table-column
        prop="amount"
        label="支付金额(元)"
        align="center"
      />
    </el-table>
    <pagination-right
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import { payrecord } from '@/api/providerAccountManagement/servicePorviderList.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: {
    PaginationRight
  },
  data() {
    return {
      queryr: {
        page: 1,
        page_size: 10
      },
      total: null,
      tableData: [],
      id: null
    }
  },
  created() {
  },
  mounted() {

  },
  methods: {
    async customeoncallback(ids) {
      this.id = ids
      const id = this.id
      const data = await payrecord(id, this.queryr)
      this.tableData = data.data.list
      this.total = data.data.total
      console.log('data', data.data.list)
    },
    // 分页
    fetchPageSize(e) {
      console.log('this.id', this.id)
      this.queryr.page_size = e
      this.customeoncallback(this.id)
    },
    fetchCurrentPage(e) {
      console.log('this.id', this.id)
      this.queryr.page = e
      this.customeoncallback(this.id)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */

</style>
